<template>
  <!-- 语文作文题 -->
  <div @mouseleave="showTopicEditorBox = false" @mouseenter="handleMouseEnter">
    <div class="writing-topic topic-box">
      <!--<custom-edit-box v-if="!msg.resolveNum&&msg.isEdit&&!isPreview" :msg="msg" :isDis="isDis" style="top:2px;" />-->
      <div>
        <div class="topic-th" v-if="!msg.resolveNum && msg.hasTitle">
          <EditScoreBox
            :msg="msg"
            @myBlur="handlerBlur"
            :isPreview="isPreview"
            v-show="msg.hasTitle"
          ></EditScoreBox>
        </div>
        <div class="write-wrap" style="position: relative">
          <TopicEditBox
            :msg="msg"
            v-if="showTopicEditorBox"
            position="top:5px"
          ></TopicEditBox>
          <div
            class="topic-bd writing-cont"
            :style="{ height: (msg.initDragHeight || 2100) + 'px' }"
            style="padding: 0 10px !important"
            v-html="msg.innerHTML"
          ></div>
        </div>
      </div>
      <div id="writing-test"></div>
    </div>
  </div>
  <!--主体-->
</template>

<script>
import $ from "jquery";
import { mapState, mapMutations, mapGetters } from "vuex";
import { mouseEventMixins } from "../../mixins/mouseEvent.mixins";
import { editScoreBoxMixins } from "../../mixins/editScoreBox.mixins";
import CustomEditBox from "@/components/TopicMakeBox/CustomEditBox";
import { CKEDITOR_CONFIG } from "@/subjects/constant";
import FillTopic from "@/assets/js/utils/FillTopic";
export default {
  name: "writingEnTopic",
  props: {
    msg: Object,
    isPreview: Boolean,
  },
  mixins: [mouseEventMixins, editScoreBoxMixins],
  components: {
    CustomEditBox,
  },
  computed: {
    ...mapState("card", {
      writeSignal: (state) => state.writeSignal,
      existHeight: (state) => state.existHeight,
      pageCell: (state) => state.pageCell,
      newTopicHeight: (state) => state.newTopicHeight,
    }),
    ...mapGetters({
      answerSheet: "answerPanel/answerSheet",
    }),
    rowNum() {
      if (this.msg.typesItem.rowNum < 1) {
        return this.msg.typesItem.rowNum.toString().split(".");
      } else {
        return [this.msg.typesItem.rowNum];
      }
    },
  },
  data() {
    return {
      showTopicEditorBox: false,
      editConfig: CKEDITOR_CONFIG,
      htmlContent: "",
      editorData: "",
      isDis: false,
      resolveEnd: true,
      moveName: "writing-en-move",
    };
  },
  created() {
    console.log(this.msg, this.editorData, this.htmlContent, "answertopic");
    this.moveName = `writing-en-move${this.msg.pageIndex}${this.msg.topicInPageIndex}`;
  },
  mounted() {
    // 这个操作永远在store更新视图之后执行
    const target = document.querySelectorAll(".topic-bd");
    const myFillTopic = new FillTopic({
      width: 1107,
      height: 706,
      canDrag: true,
      myDrag: null,
    });
    myFillTopic.init();
    // setTimeout(() => {
    //   if (this.writeSignal) {
    //     myFillTopic.recursionCutWritePage(
    //       this.pageCell.length - 1,
    //       this.existHeight
    //     );
    //   }
    //   this.setTopicSignal({ type: "writeSignal", result: false });
    // }, 200);
  },
  methods: {
    ...mapMutations({
      editorConfigDataMut: "cardMake/editorConfigDataMut",
      setTopicSignal: "card/setTopicSignal",
    }), //
    editBox(gi) {
      console.log(this.msg, gi, "msg");
    },
  },
  watch: {
    editorData: function (valNew, valOld) {
      if (this.htmlContent != valNew) {
        //编辑器操作过后不能设置
        this.isDis = true;
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.writing-topic {
  // pointer-events: none;
  .writing-cont {
    // padding-left: 5px;
    // padding-right: 5px;
    padding: 0 10px !important;
  }
  .writing {
    display: flex;
    justify-content: center;
    height: 42px;
  }
  .wri-list {
    padding-top: 10px;
  }
  .wri {
    position: relative;
    float: left;
    width: 31px;
    height: 30px;
    border: 1px solid #000;
    border-right: none;
  }
  .wri-pos {
    position: absolute;
    bottom: -13px;
    transform: scale(0.8);
  }
}
#writing-test {
  position: absolute;
  top: 1000px;
  visibility: hidden;
}
</style>
